import type { Action, DayType } from "@/types/types";
import { motion, animate } from "motion/react";
import { useRef, type Dispatch, type SubmitEvent } from "react";

export default function NewTodo({
  dispatchTodos,
  day,
}: {
  dispatchTodos: Dispatch<Action>;
  day: DayType;
}) {
  const todoRef = useRef<HTMLLIElement>(null);

  function addTodo(e: SubmitEvent) {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);

    const title = formData.get("title")?.toString();
    if (title) {
      dispatchTodos({
        type: "add",
        payload: {
          id: crypto.randomUUID(),
          title: title.trim(),
          description: "",
          done: false,
          doneBy: day.date,
        },
      });
      animate(todoRef.current, { height: [0, "3rem"] });
      form.reset();
    }
  }

  return (
    <motion.li ref={todoRef} className="todo new">
      <input type="checkbox" disabled />
      <form
        onSubmit={(e) => addTodo(e)}
        onBlur={(e) => {
          e.currentTarget.requestSubmit();
        }}
      >
        <input type="text" name="title" />
      </form>
    </motion.li>
  );
}
